import { React, useState } from "react";
import * as api from '../../api';
import { useTranslation } from "react-i18next";
import {useLocation} from "react-router-dom";

const ResetPasswordConfirm = () => {

    const { i18n } = useTranslation('common');

    const [password, setpassword] = useState('');
    const [password2, setpassword2] = useState('');
    const [errorMessage, seterrorMessage] = useState('');
    const [successMessage, setsuccessMessage] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const params = useLocation().search;
    const resetToken = new URLSearchParams(params).get('token');

  

    async function handleSubmit(e) {
        // console.log("request update password");
        e.preventDefault();
        setisLoading(true);
        seterrorMessage(i18n.language === "fr" ? "Modification du mot de passe..." : "Updating password...");
        setsuccessMessage('');

        const credentials = {
            password: password,
            token: resetToken
        }

        if (password === password2) {
            if (password.length >= 6) {
                api.ResetPasswordConfirm(credentials).then(res => {
                    // console.log(res);
                    if (res.data === "OK") {
                        // console.log("password updated");
                        setisLoading(false);
                        setsuccessMessage(i18n.language === "fr" ?
                        (
                            <p>Votre mot de passe a bien été modifié.<br/><br/><a href='/login'><button>Vous pouvez maintenant vous connecter →</button></a></p> 
                        ):(
                            <p>Your password has been updated.<br/><br/><a href='/login'><button>You may now login →</button></a></p>
                        ));
                        seterrorMessage('');
                    }
                }).catch(function (error) {
                    console.log(error);
                    setisLoading(false);
                    if (error.response) {
                        // console.log(error.response.data);
                        seterrorMessage(i18n.language === "fr" ? "Le lien de réinitialisation du mot de passe a expiré." : "The password reset link has expired.");
                    }
                    else{
                        seterrorMessage(i18n.language === "fr" ? "Une erreur est survenue." : "An error occurred.");
                    }
                    setsuccessMessage('');
                });
            }
            else{
                // console.log("password too short");
                setisLoading(false);
                seterrorMessage(i18n.language === "fr" ? "Le nouveau mot de passe doit faire au moins 6 caractères." : "The new password must be at least 6 characters long.");
                setsuccessMessage('');
            }
        }
        else{
            // console.log("passwords do not match");
            setisLoading(false);
            seterrorMessage(i18n.language === "fr" ? "Les deux champs doivent être identiques." : "The two fields bust be identical.");
            setsuccessMessage('');
        }
    }

  

    return (
        <div className="Login" >
            <h1>{i18n.language === "fr" ? "Modification du mot de passe" : "Password update"}</h1>
            <br/>
            <br/>
            {!successMessage && <form onSubmit={event => handleSubmit(event)}>
                <label style={{display : 'block'}}>
                    {i18n.language === "fr" ? "Nouveau mot de passe (6 caractères minimum):" : "New password (6 characters minimum):"}<br/>
                    <input type="password" onChange={event => setpassword(event.target.value)} />
                </label>
                <label style={{display : 'block'}}>
                    {i18n.language === "fr" ? "Confirmation du nouveau mot de passe:" : "New password confirmation:"}<br/>
                    <input type="password" onChange={event => setpassword2(event.target.value)} />
                </label>
                <p style={{ color: "red" }}>{errorMessage}</p>
                {!isLoading && <input id="savepassword" type="submit"  value={i18n.language === "fr" ? "Enregister le mot de passe" : "Save password"} />}
            </form>}
            <br/>
            <br/>
            <p style={{ color: "green" }}>{successMessage}</p>
        </div>
    );
};

export default ResetPasswordConfirm;